/** Query when opening packaging item detail from a packed item detail page */
export const PACKAGING_ITEM_DETAIL_FROM_PACKED_ITEM = 'packed-item' as const

const QUERY_FROM = 'from'
const QUERY_PACKED_ITEM_ID = 'packedItemId'

export function buildPackagingItemDetailFromPackedItemSearch(
  packedItemId: string
): string {
  const params = new URLSearchParams({
    [QUERY_FROM]: PACKAGING_ITEM_DETAIL_FROM_PACKED_ITEM,
    [QUERY_PACKED_ITEM_ID]: packedItemId,
  })
  return `?${params.toString()}`
}

export function getPackagingItemDetailPackedItemId(
  searchParams: URLSearchParams
): string | undefined {
  if (searchParams.get(QUERY_FROM) !== PACKAGING_ITEM_DETAIL_FROM_PACKED_ITEM) {
    return undefined
  }
  const packedItemId = searchParams.get(QUERY_PACKED_ITEM_ID)
  return packedItemId || undefined
}

export const PACKAGING_ITEM_DETAIL_TAB_QUERY = 'tab' as const

export type PackagingItemDetailTab =
  | 'overview'
  | 'audits'
  | 'report-audit'
  | 'heavy-metals-audit'
  | 'svhc-audit'
  | 'recyclability'
  | 'minimisation'
  | 'changelog'
  | 'output-docs'

export function parsePackagingItemDetailTab(
  searchParams: URLSearchParams
): PackagingItemDetailTab {
  const tab = searchParams.get(PACKAGING_ITEM_DETAIL_TAB_QUERY)
  if (tab === 'audits') {
    return 'audits'
  }
  if (tab === 'report-audit') {
    return 'heavy-metals-audit'
  }
  if (tab === 'heavy-metals-audit') {
    return 'heavy-metals-audit'
  }
  if (tab === 'svhc-audit') {
    return 'svhc-audit'
  }
  if (tab === 'recyclability') {
    return 'recyclability'
  }
  if (tab === 'minimisation') {
    return 'minimisation'
  }
  if (tab === 'changelog') {
    return 'changelog'
  }
  if (tab === 'output-docs') {
    return 'output-docs'
  }
  return 'overview'
}

export function setPackagingItemDetailTabSearchParams(
  previous: URLSearchParams,
  tab: PackagingItemDetailTab
): URLSearchParams {
  const next = new URLSearchParams(previous)
  if (tab === 'overview') {
    next.delete(PACKAGING_ITEM_DETAIL_TAB_QUERY)
  } else {
    next.set(PACKAGING_ITEM_DETAIL_TAB_QUERY, tab)
  }
  return next
}
